var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("article", { staticClass: "box" }, [
          _c("div", { staticClass: "columns is-gapless" }, [
            _vm._m(0),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control is-pulled-right" }, [
                  _c("div", { staticClass: "is-pulled-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary ml-3",
                        on: {
                          click: function ($event) {
                            return _vm.handleFetch()
                          },
                        },
                      },
                      [_vm._m(1), _c("span", [_vm._v("Fetch")])]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "button is-success tooltip ml-3",
                        attrs: { "data-tooltip": "Sync" },
                        on: {
                          click: function ($event) {
                            return _vm.handleSync()
                          },
                        },
                      },
                      [_vm._m(2), _c("span", [_vm._v("Sync")])]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary ml-3",
                        on: {
                          click: function ($event) {
                            return _vm.toggleRepXLogModal()
                          },
                        },
                      },
                      [_vm._m(3), _c("span", [_vm._v("View Log")])]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm.isRepxLogsActive
            ? _c("div", { staticClass: "columns" }, [
                _c(
                  "div",
                  { staticClass: "column is-one-fifth" },
                  [
                    _c("repx-repair-stages", {
                      ref: "repxRepairStages",
                      attrs: { "quote-id": _vm.value.quoteId },
                      on: { save: _vm.handleSaveRepxRepairStages },
                      model: {
                        value: _vm.value.repx,
                        callback: function ($$v) {
                          _vm.$set(_vm.value, "repx", $$v)
                        },
                        expression: "value.repx",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("quote-vehicle-damage", {
                      ref: "quoteVehicleDamageRef",
                      attrs: { "quote-id": _vm.value.quoteId },
                    }),
                  ],
                  1
                ),
                _vm.isVehicleDamageActive
                  ? _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _c("repx-list", {
                          attrs: {
                            "hide-filter": _vm.hideFilter,
                            "quote-id": _vm.value.quoteId,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.value && _vm.isRepXLogModalActive
        ? _c(
            "base-modal-ex",
            {
              attrs: {
                active: _vm.isRepXLogModalActive,
                "animation-in": _vm.animationIn,
                "animation-out": _vm.animationOut,
                "animation-duration": _vm.animationDuration,
                "can-cancel": false,
                "min-width": 80,
                "min-height": 85,
                "has-modal-card": "",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isRepXLogModalActive = $event
                },
                cancel: function ($event) {
                  return _vm.toggleRepXLogModal()
                },
              },
            },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _c("span", [_vm._v("RepX Log")]),
                ]),
              ]),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _c("repx-list", {
                    attrs: {
                      "hide-filter": _vm.hideFilter,
                      "quote-id": _vm.value.quoteId,
                    },
                  }),
                ],
                1
              ),
              _c(
                "footer",
                {
                  staticClass:
                    "modal-card-foot is-flex is-justify-content-flex-end",
                },
                [
                  _c("div", { staticClass: "buttons" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button tooltip",
                        attrs: { "data-tooltip": "Close" },
                        on: {
                          click: function ($event) {
                            return _vm.toggleRepXLogModal()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", { staticClass: "mdi mdi-20px mdi-close" }),
                        ]),
                        _c("span", [_vm._v("Close")]),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("RepX")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-cloud-download mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-sync mdi-20px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-eye" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }